var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.infoBlock},[(_vm.icon)?_c('div',{class:[_vm.$style.componentIcon, _vm.$style[_vm.variant]]},[_c('icon',{class:_vm.$style.blockIcon,attrs:{"icon":_vm.icon}})],1):_vm._e(),_c('div',{class:_vm.$style.content},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }